// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.schedule-section {
  min-height: 100vh;
  background: white;
  font-family: 'Segoe UI', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  color: #1f2937;
}


/* Стили для аудитории замены */
.replacement-room {
  color: #d32f2f;
  font-weight: bold;
  font-size: 0.85em;
  margin-top: 4px;
  padding: 2px 6px;
  background-color: rgba(244, 67, 54, 0.1);
  border-radius: 4px;
  border-left: 2px solid #f44336;
}
/* стили для кнопки обновления */
.refresh-button {
  background: none;
  border: 1px solid #ddd;
  font-size: 1.2em;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
}

.refresh-button:hover {
  background-color: #f8f9fa;
  transform: scale(1.05);
}

.refresh-button:active {
  transform: scale(0.95);
}

.refresh-icon {
  width: 20px;
  height: 20px;
  transition: transform 0.3s ease;
}

.refresh-button:hover .refresh-icon {
  transform: rotate(180deg);
}

.refresh-button.loading .refresh-icon {
  animation: spin 1s linear infinite;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-left: 10px;
}

/* стили для модального окна */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 20px;
  padding: 0;
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: modalAppear 0.3s ease;
}

@keyframes modalAppear {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(0, 47, 167, 0.1);
  background: rgba(0, 47, 167, 0.05);
}

.modal-header h3 {
  margin: 0;
  color: #002FA7;
  font-size: 1.2em;
  font-weight: 600;
}

.modal-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #64748b;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.modal-close:hover {
  background: rgba(0, 47, 167, 0.1);
  color: #002FA7;
}

.modal-body {
  padding: 24px;
  max-height: 400px;
  overflow-y: auto;
}

/* стили для списка оценок */
.marks-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.marks-header {
  display: grid;
  grid-template-columns: 60px 80px 1fr;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 2px solid rgba(0, 47, 167, 0.1);
  font-weight: 600;
  color: #002FA7;
  font-size: 0.9em;
}

.mark-item {
  display: grid;
  grid-template-columns: 60px 80px 1fr;
  gap: 12px;
  padding: 12px 16px;
  background: rgba(0, 47, 167, 0.03);
  border-radius: 12px;
  border: 1px solid rgba(0, 47, 167, 0.1);
  transition: all 0.3s ease;
}

.mark-item:hover {
  background: rgba(0, 47, 167, 0.08);
  border-color: rgba(0, 47, 167, 0.3);
}

.mark-number {
  font-weight: 600;
  color: #64748b;
  display: flex;
  align-items: center;
}

.mark-value {
  font-weight: 700;
  font-size: 1.1em;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  padding: 4px 8px;
}

.mark-value.good {
  color: #10b981;
  background: rgba(16, 185, 129, 0.1);
}

.mark-value.average {
  color: #f59e0b;
  background: rgba(245, 158, 11, 0.1);
}

.mark-value.poor {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
}

.mark-teacher {
  color: #64748b;
  font-size: 0.9em;
  display: flex;
  align-items: center;
}

.no-marks {
  text-align: center;
  padding: 40px 20px;
  color: #64748b;
}

.no-marks p {
  margin: 0;
  font-size: 1.1em;
}

/* стили для кликабельных блоков пар */
.clickable-lesson {
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.clickable-lesson::after {
  content: '';
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20px;
  height: 20px;
  background-size: contain;
  background-repeat: no-repeat;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.clickable-lesson:hover::after {
  opacity: 0.7;
}

.lesson-row.clickable-lesson:hover,
.separated-lesson-row.clickable-lesson:hover {
  border-color: #002FA7;
}

.next-lesson.clickable-lesson:hover .next-lesson-card {
  border-color: #002FA7;
}

/* стили для подгруппы */
.lesson-subgroup {
  font-weight: 500;
  color: #666;
  font-size: 13px;
  margin-top: 2px;
}

.separated-teacher-room .lesson-subgroup {
  margin-top: 2px;
}

/* загрузка и ошибки */
.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 50vh;
  color: #002FA7;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(0, 47, 167, 0.3);
  border-left: 4px solid #002FA7;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading p {
  font-size: 18px;
  margin: 0;
}

.error {
  text-align: center;
  padding: 40px 20px;
  color: #ef4444;
  font-size: 18px;
  background: white;
  border-radius: 20px;
  margin: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

/* фильтр верхняя/нижняя неделя */
.schedule-header-week {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  padding: 0 40px;
}

.week-type-tabs {
  display: flex;
  background: rgba(0, 47, 167, 0.1);
  border-radius: 12px;
  padding: 4px;
  gap: 4px;
}

.week-type-tab {
  padding: 10px 20px;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9em;
  font-weight: 500;
  color: #64748b;
  transition: all 0.3s ease;
}

.week-type-tab.active {
  background: white;
  color: #002FA7;
  box-shadow: 0 2px 8px rgba(0, 47, 167, 0.2);
}

/* вкладки дни недели */
.day-tabs-container {
  background: white;
  padding: 0 40px;
  margin-bottom: 10px;
  margin-top: 20px;
}

.day-tabs {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 8px;
  background: rgba(0, 47, 167, 0.05);
  border: 1px solid rgba(0, 47, 167, 0.1);
  border-radius: 16px;
  padding: 8px;
}

.day-tab {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 8px;
  border: 2px solid transparent;
  border-radius: 12px;
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 135px;
  color: #002FA7; 
}

.day-tab:hover {
  background: rgba(0, 47, 167, 0.1);
  border-color: rgba(0, 47, 167, 0.3);
}

.day-tab.active {
  background: #002FA7;
  border-color: #002FA7;
  color: white; 
}

.day-tab.current-day:not(.active) {
  border-color: #002FA7;
  background: rgba(0, 47, 167, 0.08);
}

.day-tab-weekday {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  text-align: center;
}

.day-tab-date {
  font-size: 13px;
  font-weight: 500;
  opacity: 0.8;
}

.day-tab.active .day-tab-date {
  opacity: 1;
}

.week-indicator {
  font-size: 11px;
  font-weight: 500;
  margin-top: 4px;
  opacity: 0.7;
  color: #002FA7;
}

.day-tab.active {
  color: rgba(255, 255, 255, 0.9);
}

/* контейнер расписания */
.schedule-container {
  background: white;
  border-radius: 20px;
  margin: 0 40px 40px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 47, 167, 0.1);
  overflow: hidden;
}

.schedule-content {
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 30px;
  padding-top: 15px;
}

.day-schedule-content {
  min-height: 100px;
}

/* карточки пар */
.lesson-row {
  background: rgba(0, 47, 167, 0.05);
  border-radius: 15px;
  padding: 20px;
  margin-bottom: 15px;
  border: 1px solid rgba(0, 47, 167, 0.1);
  transition: all 0.3s ease;
}

.lesson-row:hover {
  background: rgba(0, 47, 167, 0.08);
  border-color: rgba(0, 47, 167, 0.3);
}

.lesson-time {
  display: inline-block;
  background: #002FA7;
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.85em;
  font-weight: 600;
  margin-bottom: 12px;
}

.lesson-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 15px;
}

.lesson-info {
  flex: 1 1;
}

.lesson-subject {
  font-weight: 600;
  color: #2d3748;
  font-size: 1.1em;
  margin-bottom: 8px;
  line-height: 1.4;
}

.lesson-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.lesson-teacher-room {
  color: #002FA7;
  font-weight: 500;
  font-size: 0.9em;
}

.lesson-room {
  color: #718096;
  font-size: 0.9em;
  font-weight: 500;
}

/* разделенные пары */
.separated-lesson-row {
  background: rgba(0, 47, 167, 0.05);
  border-radius: 15px;
  padding: 20px;
  margin-bottom: 15px;
  border: 1px solid rgba(0, 47, 167, 0.1);
  transition: all 0.3s ease;
}

.separated-lesson-row:hover {
  background: rgba(0, 47, 167, 0.08);
  border-color: rgba(0, 47, 167, 0.3);
}

.separated-time {
  display: inline-block;
  background: #002FA7;
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.85em;
  font-weight: 600;
}

.separated-lesson-content {
  display: flex;
  flex-direction: column;
  gap: 0;
  border-radius: 10px;
  overflow: hidden;
}

.separated-lesson-item {
  padding-left: 0px;
  padding-right: 15px;
  padding-bottom: 15px;
  padding-top: 15px;
  background: transparent;
  position: relative;
  transition: all 0.3s ease;
}

.separated-subject {
  font-weight: 600;
  color: #2d3748;
  font-size: 1.1em;
  margin-bottom: 8px;
}

.separated-lesson-meta {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.separated-teacher-room {
  color: #002FA7;
  font-weight: 500;
  font-size: 0.9em;
}

.separated-room {
  color: #718096;
  font-size: 0.9em;
  font-weight: 500;
}

.separated-subgroup {
  font-weight: 500;
  color: #666;
  font-size: 0.9em;
  margin-top: 2px;
}

/* нет пар */
.no-classes {
  background: rgba(0, 47, 167, 0.05);
  border-radius: 15px;
  padding: 40px 20px;
  text-align: center;
  border: 1px solid rgba(0, 47, 167, 0.1);
}

.no-classes-text {
  color: #718096;
  font-size: 1.1em;
  font-weight: 500;
  margin: 0;
}

/* следующая пара */
.next-lesson {
  margin-top: 30px;
  padding-top: 25px;
  border-top: 2px solid rgba(0, 47, 167, 0.1);
}

.next-lesson-title {
  margin-bottom: 15px;
}

.next-lesson-title h3 {
  margin: 0;
  font-size: 1.3em;
  font-weight: 600;
  color: #2d3748;
}

.next-lesson-card {
  background: rgba(0, 47, 167, 0.05);
  border-radius: 15px;
  padding: 20px;
  border: 1px solid rgba(0, 47, 167, 0.1);
}

.next-lesson-subject {
  font-weight: 600;
  color: #002FA7;
  font-size: 1.1em;
  margin-bottom: 15px;
}

.next-lesson-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.next-lesson-detail {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.detail-label {
  font-weight: 500;
  color: #64748b;
  font-size: 0.9em;
}

.detail-value {
  font-weight: 600;
  color: #002FA7;
  font-size: 0.95em;
}

.no-next-lesson {
  text-align: center;
  color: #718096;
  padding: 10px 0;
}

/* стили для информации о группе (для преподавателей) */
.lesson-group-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.lesson-group {
  font-weight: 600;
  color: #002FA7;
  font-size: 0.9em;
}

/* анимации */
@keyframes fadeIn {
  from { 
    opacity: 0; 
    transform: translateY(20px); 
  }
  to { 
    opacity: 1; 
    transform: translateY(0); 
  }
}

.schedule-container {
  animation: fadeIn 0.5s ease;
}

/* стили для замен */
.lesson-row.replacement {
  background-color: #ffebee;
  border-left: 4px solid #f44336;
  margin-top: 0;
}

.separated-lesson-item.replacement {
  background-color: #ffebee;
  border-left: 4px solid #f44336;
  padding-left: 15px;
  border-radius: 5px;
}

.separated-lesson-item.clickable-lesson.replacement:hover {
  background-color: #ffe0e5;
}

.next-lesson-card.replacement {
  background-color: #ffebee;
  border-left: 4px solid #f44336;
}`, "",{"version":3,"sources":["webpack://./src/st-components/ScheduleSection.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gIAAgI;EAChI,cAAc;AAChB;;;AAGA,+BAA+B;AAC/B;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,8BAA8B;AAChC;AACA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;EAC9C,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,eAAe;EACf,8CAA8C;EAC9C,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,4BAA4B;EAC5B,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,8BAA8B;EAC9B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,mBAAmB;EACnB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,2CAA2C;AAC7C;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,kCAAkC;EAClC,uCAAuC;EACvC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC","sourcesContent":[".schedule-section {\n  min-height: 100vh;\n  background: white;\n  font-family: 'Segoe UI', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;\n  color: #1f2937;\n}\n\n\n/* Стили для аудитории замены */\n.replacement-room {\n  color: #d32f2f;\n  font-weight: bold;\n  font-size: 0.85em;\n  margin-top: 4px;\n  padding: 2px 6px;\n  background-color: rgba(244, 67, 54, 0.1);\n  border-radius: 4px;\n  border-left: 2px solid #f44336;\n}\n/* стили для кнопки обновления */\n.refresh-button {\n  background: none;\n  border: 1px solid #ddd;\n  font-size: 1.2em;\n  cursor: pointer;\n  padding: 8px 12px;\n  border-radius: 6px;\n  transition: all 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n}\n\n.refresh-button:hover {\n  background-color: #f8f9fa;\n  transform: scale(1.05);\n}\n\n.refresh-button:active {\n  transform: scale(0.95);\n}\n\n.refresh-icon {\n  width: 20px;\n  height: 20px;\n  transition: transform 0.3s ease;\n}\n\n.refresh-button:hover .refresh-icon {\n  transform: rotate(180deg);\n}\n\n.refresh-button.loading .refresh-icon {\n  animation: spin 1s linear infinite;\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding-left: 10px;\n}\n\n/* стили для модального окна */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 20px;\n  padding: 0;\n  max-width: 500px;\n  width: 90%;\n  max-height: 80vh;\n  overflow: hidden;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  animation: modalAppear 0.3s ease;\n}\n\n@keyframes modalAppear {\n  from {\n    opacity: 0;\n    transform: scale(0.9) translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid rgba(0, 47, 167, 0.1);\n  background: rgba(0, 47, 167, 0.05);\n}\n\n.modal-header h3 {\n  margin: 0;\n  color: #002FA7;\n  font-size: 1.2em;\n  font-weight: 600;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #64748b;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n}\n\n.modal-close:hover {\n  background: rgba(0, 47, 167, 0.1);\n  color: #002FA7;\n}\n\n.modal-body {\n  padding: 24px;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n/* стили для списка оценок */\n.marks-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.marks-header {\n  display: grid;\n  grid-template-columns: 60px 80px 1fr;\n  gap: 12px;\n  padding: 12px 0;\n  border-bottom: 2px solid rgba(0, 47, 167, 0.1);\n  font-weight: 600;\n  color: #002FA7;\n  font-size: 0.9em;\n}\n\n.mark-item {\n  display: grid;\n  grid-template-columns: 60px 80px 1fr;\n  gap: 12px;\n  padding: 12px 16px;\n  background: rgba(0, 47, 167, 0.03);\n  border-radius: 12px;\n  border: 1px solid rgba(0, 47, 167, 0.1);\n  transition: all 0.3s ease;\n}\n\n.mark-item:hover {\n  background: rgba(0, 47, 167, 0.08);\n  border-color: rgba(0, 47, 167, 0.3);\n}\n\n.mark-number {\n  font-weight: 600;\n  color: #64748b;\n  display: flex;\n  align-items: center;\n}\n\n.mark-value {\n  font-weight: 700;\n  font-size: 1.1em;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  padding: 4px 8px;\n}\n\n.mark-value.good {\n  color: #10b981;\n  background: rgba(16, 185, 129, 0.1);\n}\n\n.mark-value.average {\n  color: #f59e0b;\n  background: rgba(245, 158, 11, 0.1);\n}\n\n.mark-value.poor {\n  color: #ef4444;\n  background: rgba(239, 68, 68, 0.1);\n}\n\n.mark-teacher {\n  color: #64748b;\n  font-size: 0.9em;\n  display: flex;\n  align-items: center;\n}\n\n.no-marks {\n  text-align: center;\n  padding: 40px 20px;\n  color: #64748b;\n}\n\n.no-marks p {\n  margin: 0;\n  font-size: 1.1em;\n}\n\n/* стили для кликабельных блоков пар */\n.clickable-lesson {\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.clickable-lesson::after {\n  content: '';\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  width: 20px;\n  height: 20px;\n  background-size: contain;\n  background-repeat: no-repeat;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.clickable-lesson:hover::after {\n  opacity: 0.7;\n}\n\n.lesson-row.clickable-lesson:hover,\n.separated-lesson-row.clickable-lesson:hover {\n  border-color: #002FA7;\n}\n\n.next-lesson.clickable-lesson:hover .next-lesson-card {\n  border-color: #002FA7;\n}\n\n/* стили для подгруппы */\n.lesson-subgroup {\n  font-weight: 500;\n  color: #666;\n  font-size: 13px;\n  margin-top: 2px;\n}\n\n.separated-teacher-room .lesson-subgroup {\n  margin-top: 2px;\n}\n\n/* загрузка и ошибки */\n.loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 50vh;\n  color: #002FA7;\n}\n\n.loading-spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid rgba(0, 47, 167, 0.3);\n  border-left: 4px solid #002FA7;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 20px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loading p {\n  font-size: 18px;\n  margin: 0;\n}\n\n.error {\n  text-align: center;\n  padding: 40px 20px;\n  color: #ef4444;\n  font-size: 18px;\n  background: white;\n  border-radius: 20px;\n  margin: 20px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n}\n\n/* фильтр верхняя/нижняя неделя */\n.schedule-header-week {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 20px;\n  padding: 0 40px;\n}\n\n.week-type-tabs {\n  display: flex;\n  background: rgba(0, 47, 167, 0.1);\n  border-radius: 12px;\n  padding: 4px;\n  gap: 4px;\n}\n\n.week-type-tab {\n  padding: 10px 20px;\n  border: none;\n  background: transparent;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.9em;\n  font-weight: 500;\n  color: #64748b;\n  transition: all 0.3s ease;\n}\n\n.week-type-tab.active {\n  background: white;\n  color: #002FA7;\n  box-shadow: 0 2px 8px rgba(0, 47, 167, 0.2);\n}\n\n/* вкладки дни недели */\n.day-tabs-container {\n  background: white;\n  padding: 0 40px;\n  margin-bottom: 10px;\n  margin-top: 20px;\n}\n\n.day-tabs {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: 8px;\n  background: rgba(0, 47, 167, 0.05);\n  border: 1px solid rgba(0, 47, 167, 0.1);\n  border-radius: 16px;\n  padding: 8px;\n}\n\n.day-tab {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 12px 8px;\n  border: 2px solid transparent;\n  border-radius: 12px;\n  background: transparent;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 135px;\n  color: #002FA7; \n}\n\n.day-tab:hover {\n  background: rgba(0, 47, 167, 0.1);\n  border-color: rgba(0, 47, 167, 0.3);\n}\n\n.day-tab.active {\n  background: #002FA7;\n  border-color: #002FA7;\n  color: white; \n}\n\n.day-tab.current-day:not(.active) {\n  border-color: #002FA7;\n  background: rgba(0, 47, 167, 0.08);\n}\n\n.day-tab-weekday {\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 4px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n  text-align: center;\n}\n\n.day-tab-date {\n  font-size: 13px;\n  font-weight: 500;\n  opacity: 0.8;\n}\n\n.day-tab.active .day-tab-date {\n  opacity: 1;\n}\n\n.week-indicator {\n  font-size: 11px;\n  font-weight: 500;\n  margin-top: 4px;\n  opacity: 0.7;\n  color: #002FA7;\n}\n\n.day-tab.active {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n/* контейнер расписания */\n.schedule-container {\n  background: white;\n  border-radius: 20px;\n  margin: 0 40px 40px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(0, 47, 167, 0.1);\n  overflow: hidden;\n}\n\n.schedule-content {\n  padding-left: 30px;\n  padding-right: 30px;\n  padding-bottom: 30px;\n  padding-top: 15px;\n}\n\n.day-schedule-content {\n  min-height: 100px;\n}\n\n/* карточки пар */\n.lesson-row {\n  background: rgba(0, 47, 167, 0.05);\n  border-radius: 15px;\n  padding: 20px;\n  margin-bottom: 15px;\n  border: 1px solid rgba(0, 47, 167, 0.1);\n  transition: all 0.3s ease;\n}\n\n.lesson-row:hover {\n  background: rgba(0, 47, 167, 0.08);\n  border-color: rgba(0, 47, 167, 0.3);\n}\n\n.lesson-time {\n  display: inline-block;\n  background: #002FA7;\n  color: white;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 0.85em;\n  font-weight: 600;\n  margin-bottom: 12px;\n}\n\n.lesson-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 15px;\n}\n\n.lesson-info {\n  flex: 1;\n}\n\n.lesson-subject {\n  font-weight: 600;\n  color: #2d3748;\n  font-size: 1.1em;\n  margin-bottom: 8px;\n  line-height: 1.4;\n}\n\n.lesson-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.lesson-teacher-room {\n  color: #002FA7;\n  font-weight: 500;\n  font-size: 0.9em;\n}\n\n.lesson-room {\n  color: #718096;\n  font-size: 0.9em;\n  font-weight: 500;\n}\n\n/* разделенные пары */\n.separated-lesson-row {\n  background: rgba(0, 47, 167, 0.05);\n  border-radius: 15px;\n  padding: 20px;\n  margin-bottom: 15px;\n  border: 1px solid rgba(0, 47, 167, 0.1);\n  transition: all 0.3s ease;\n}\n\n.separated-lesson-row:hover {\n  background: rgba(0, 47, 167, 0.08);\n  border-color: rgba(0, 47, 167, 0.3);\n}\n\n.separated-time {\n  display: inline-block;\n  background: #002FA7;\n  color: white;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 0.85em;\n  font-weight: 600;\n}\n\n.separated-lesson-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.separated-lesson-item {\n  padding-left: 0px;\n  padding-right: 15px;\n  padding-bottom: 15px;\n  padding-top: 15px;\n  background: transparent;\n  position: relative;\n  transition: all 0.3s ease;\n}\n\n.separated-subject {\n  font-weight: 600;\n  color: #2d3748;\n  font-size: 1.1em;\n  margin-bottom: 8px;\n}\n\n.separated-lesson-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.separated-teacher-room {\n  color: #002FA7;\n  font-weight: 500;\n  font-size: 0.9em;\n}\n\n.separated-room {\n  color: #718096;\n  font-size: 0.9em;\n  font-weight: 500;\n}\n\n.separated-subgroup {\n  font-weight: 500;\n  color: #666;\n  font-size: 0.9em;\n  margin-top: 2px;\n}\n\n/* нет пар */\n.no-classes {\n  background: rgba(0, 47, 167, 0.05);\n  border-radius: 15px;\n  padding: 40px 20px;\n  text-align: center;\n  border: 1px solid rgba(0, 47, 167, 0.1);\n}\n\n.no-classes-text {\n  color: #718096;\n  font-size: 1.1em;\n  font-weight: 500;\n  margin: 0;\n}\n\n/* следующая пара */\n.next-lesson {\n  margin-top: 30px;\n  padding-top: 25px;\n  border-top: 2px solid rgba(0, 47, 167, 0.1);\n}\n\n.next-lesson-title {\n  margin-bottom: 15px;\n}\n\n.next-lesson-title h3 {\n  margin: 0;\n  font-size: 1.3em;\n  font-weight: 600;\n  color: #2d3748;\n}\n\n.next-lesson-card {\n  background: rgba(0, 47, 167, 0.05);\n  border-radius: 15px;\n  padding: 20px;\n  border: 1px solid rgba(0, 47, 167, 0.1);\n}\n\n.next-lesson-subject {\n  font-weight: 600;\n  color: #002FA7;\n  font-size: 1.1em;\n  margin-bottom: 15px;\n}\n\n.next-lesson-details {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.next-lesson-detail {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.detail-label {\n  font-weight: 500;\n  color: #64748b;\n  font-size: 0.9em;\n}\n\n.detail-value {\n  font-weight: 600;\n  color: #002FA7;\n  font-size: 0.95em;\n}\n\n.no-next-lesson {\n  text-align: center;\n  color: #718096;\n  padding: 10px 0;\n}\n\n/* стили для информации о группе (для преподавателей) */\n.lesson-group-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.lesson-group {\n  font-weight: 600;\n  color: #002FA7;\n  font-size: 0.9em;\n}\n\n/* анимации */\n@keyframes fadeIn {\n  from { \n    opacity: 0; \n    transform: translateY(20px); \n  }\n  to { \n    opacity: 1; \n    transform: translateY(0); \n  }\n}\n\n.schedule-container {\n  animation: fadeIn 0.5s ease;\n}\n\n/* стили для замен */\n.lesson-row.replacement {\n  background-color: #ffebee;\n  border-left: 4px solid #f44336;\n  margin-top: 0;\n}\n\n.separated-lesson-item.replacement {\n  background-color: #ffebee;\n  border-left: 4px solid #f44336;\n  padding-left: 15px;\n  border-radius: 5px;\n}\n\n.separated-lesson-item.clickable-lesson.replacement:hover {\n  background-color: #ffe0e5;\n}\n\n.next-lesson-card.replacement {\n  background-color: #ffebee;\n  border-left: 4px solid #f44336;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
